import React, { useEffect, useState } from 'react'
import { Button, Select, Space, Tag, Tooltip, DatePicker, Divider } from 'antd'
import EmptyContent from '../../components/EmptyContent'
import { inject, observer } from 'mobx-react'
import queryString from 'query-string'
import { useHistory, useLocation } from 'react-router-dom'
import { ASSIGNEE_TYPE, ISO_DATE_FORMAT } from '../../constants'
import SelectPeoplePopup from '../../components/SelectPeoplePopup/SelectPeoplePopup'
import SelectGroupPopup from '../../components/SelectGroupPopup/SelectGroupPopup'
import { blue, yellowPrimary } from '../../color'
import { BankOutlined, TeamOutlined, UserOutlined } from '@ant-design/icons'
import { SelectList } from '../MissionCreatePage/MissionCreatePageStyled'
import { AvatarHasName } from '../../components/Common/Avatar'
import moment from 'moment'

const { Option } = Select

const Search = props => {
  const {
    taskStore,
    taskLevelList,
    authenticationStore,
    dispatchUserFilter,
    selectPeopleStore,
    isVisibleCreateMissionPopup,
    onClose,
  } = props

  const {
    selectUserData,
    selectDepartmentData,
    selectGroupData,
    handleOpenSelectUserDepartmentPopup,
    handleCancelSelectUserDepartment,
    handleOpenSelectGroupPopup,
    handleCancelSelectGroup,
    assigneePopupType,
    isVisibleSelectUserDepartmentPopup,
    setIsVisibleSelectUserDepartmentPopup,
    isVisibleSelectGroupPopup,
    setIsVisibleSelectGroupPopup,
  } = selectPeopleStore

  const [leaderList, setLeaderList] = useState([])
  const [handlerList, setHandlerList] = useState([])
  const [combinerList, setCombinerList] = useState([])

  useEffect(() => {
    setLeaderList([
      ...selectUserData[ASSIGNEE_TYPE.LEADER],
      ...selectDepartmentData[ASSIGNEE_TYPE.LEADER],
      ...selectGroupData[ASSIGNEE_TYPE.LEADER],
    ])
    setHandlerList([
      ...selectUserData[ASSIGNEE_TYPE.HANDLER],
      ...selectDepartmentData[ASSIGNEE_TYPE.HANDLER],
      ...selectGroupData[ASSIGNEE_TYPE.HANDLER],
    ])
    setCombinerList([
      ...selectUserData[ASSIGNEE_TYPE.COMBINER],
      ...selectDepartmentData[ASSIGNEE_TYPE.COMBINER],
      ...selectGroupData[ASSIGNEE_TYPE.COMBINER],
    ])
  }, [selectUserData, selectDepartmentData, selectGroupData])

  const location = useLocation()
  const history = useHistory()
  const queryStringParse = queryString.parse(location.search, {
    arrayFormat: 'index',
  })

  // LOCAL STATE
  const [localParams, setLocalParams] = useState({
    date_by: queryStringParse.date_by || 'DISPLAY_DATE',
    from_date:
      queryStringParse.from_date ||
      moment().startOf('month').format(ISO_DATE_FORMAT),
    to_date:
      queryStringParse.to_date ||
      moment().endOf('month').format(ISO_DATE_FORMAT),
    tien_do: queryStringParse.tien_do,
    id_task_level: queryStringParse.id_task_level,
    loai_nhiem_vu: queryStringParse.loai_nhiem_vu,
  })

  // Sync local state when URL changes
  useEffect(() => {
    setLocalParams({
      date_by: queryStringParse.date_by || 'DISPLAY_DATE',
      from_date:
        queryStringParse.from_date ||
        moment().startOf('month').format(ISO_DATE_FORMAT),
      to_date:
        queryStringParse.to_date ||
        moment().endOf('month').format(ISO_DATE_FORMAT),
      tien_do: queryStringParse.tien_do,
      id_task_level: queryStringParse.id_task_level,
      loai_nhiem_vu: queryStringParse.loai_nhiem_vu,
    })
  }, [location.search])

  const handleApply = () => {
    const qs = queryString.stringify(
      {
        ...queryStringParse,
        date_by: localParams.date_by,
        from_date: localParams.from_date,
        to_date: localParams.to_date,
        tien_do: localParams.tien_do || null,
        id_task_level: localParams.id_task_level || null,
        loai_nhiem_vu: localParams.loai_nhiem_vu || null,
      },
      { skipNull: true, arrayFormat: 'index' }
    )
    history.replace(`/mission?${qs}`)
    if (onClose) onClose()
  }

  const handleClear = () => {
    setLocalParams({
      date_by: 'DISPLAY_DATE',
      from_date: moment().startOf('month').format(ISO_DATE_FORMAT),
      to_date: moment().endOf('month').format(ISO_DATE_FORMAT),
      tien_do: undefined,
      id_task_level: undefined,
      loai_nhiem_vu: undefined,
    })
    const qs = queryString.stringify(
      {
        ...queryStringParse,
        date_by: 'DISPLAY_DATE',
        from_date: moment().startOf('month').format(ISO_DATE_FORMAT),
        to_date: moment().endOf('month').format(ISO_DATE_FORMAT),
        tien_do: null,
        id_task_level: null,
        loai_nhiem_vu: null,
      },
      { skipNull: true, arrayFormat: 'index' }
    )
    history.replace(`/mission?${qs}`)
    if (onClose) onClose()
  }

  const handleSubmitSelect = () => {
    setIsVisibleSelectGroupPopup(false)
    setIsVisibleSelectUserDepartmentPopup(false)
    if (selectGroupData[assigneePopupType]?.length > 0) {
      dispatchUserFilter({
        type: assigneePopupType,
        value: selectGroupData[assigneePopupType][0].id,
        fullName: selectGroupData[assigneePopupType][0].full_name,
        assigneeType: ASSIGNEE_TYPE.GROUP,
      })
      return
    }
    if (selectUserData[assigneePopupType]?.length > 0) {
      dispatchUserFilter({
        type: assigneePopupType,
        value: selectUserData[assigneePopupType][0].id,
        fullName: selectUserData[assigneePopupType][0].full_name,
        assigneeType: ASSIGNEE_TYPE.USER,
      })
      return
    }
    if (selectDepartmentData[assigneePopupType]?.length > 0) {
      dispatchUserFilter({
        type: assigneePopupType,
        value: selectDepartmentData[assigneePopupType][0].id,
        fullName: selectDepartmentData[assigneePopupType][0].full_name,
        assigneeType: ASSIGNEE_TYPE.DEPARTMENT,
      })
      return
    }
    dispatchUserFilter({
      type: assigneePopupType,
      value: null,
      fullName: null,
      assigneeType: ASSIGNEE_TYPE.USER,
    })
  }

  return (
    <div style={{ width: 350, padding: '8px', maxHeight: 'calc(100vh - 200px)', overflowY: 'auto', overflowX: 'hidden' }}>
      <div style={{ marginBottom: 16 }}>
        <div style={{ marginBottom: 8, color: '#666' }}>Lọc theo</div>
        <Select
          style={{ width: '100%' }}
          value={localParams.date_by}
          onChange={v => setLocalParams({ ...localParams, date_by: v })}>
          <Option value="DISPLAY_DATE">Lọc theo Tháng hiển thị</Option>
          <Option value="CREATED_DATE">Lọc theo Ngày tạo</Option>
        </Select>
      </div>

      <div style={{ marginBottom: 16 }}>
        <div style={{ marginBottom: 8, color: '#666' }}>Tháng</div>
        <DatePicker
          style={{ width: '100%' }}
          picker="month"
          format="MM/YYYY"
          value={localParams.from_date ? moment(localParams.from_date) : null}
          onChange={v =>
            setLocalParams({
              ...localParams,
              from_date: v ? v.startOf('month').format(ISO_DATE_FORMAT) : null,
              to_date: v ? v.endOf('month').format(ISO_DATE_FORMAT) : null,
            })
          }
        />
      </div>

      <div style={{ marginBottom: 16 }}>
        <div style={{ marginBottom: 8, color: '#666' }}>Tiến độ</div>
        <Select
          style={{ width: '100%' }}
          allowClear
          placeholder="Lọc theo tiến độ"
          value={localParams.tien_do}
          onChange={v => setLocalParams({ ...localParams, tien_do: v })}>
          <Option value="001">Hoàn thành</Option>
          <Option value="002">Chưa hoàn thành</Option>
        </Select>
      </div>

      <div style={{ marginBottom: 16 }}>
        <div style={{ marginBottom: 8, color: '#666' }}>Cấp giao nhiệm vụ</div>
        <Select
          style={{ width: '100%' }}
          allowClear
          placeholder="Chọn cấp giao nhiệm vụ"
          value={localParams.id_task_level}
          onChange={v => setLocalParams({ ...localParams, id_task_level: v })}>
          {taskLevelList?.map(taskLevel => (
            <Option key={taskLevel.id_level} value={taskLevel.id_level}>
              {taskLevel.ten_cap}
            </Option>
          ))}
        </Select>
      </div>

      <div style={{ marginBottom: 16 }}>
        <div style={{ marginBottom: 8, color: '#666' }}>Loại nhiệm vụ</div>
        <Select
          style={{ width: '100%' }}
          allowClear
          placeholder="Chọn loại nhiệm vụ"
          value={localParams.loai_nhiem_vu}
          onChange={v => setLocalParams({ ...localParams, loai_nhiem_vu: v })}>
          {/* Options if available */}
        </Select>
      </div>

      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: 8,
        }}>
        <span style={{ color: '#666' }}>Lãnh đạo giao việc:</span>
        <Button
          icon={<TeamOutlined />}
          style={{ color: '#fa8c16', borderColor: '#d9d9d9' }}
          onClick={() => {
            setIsVisibleSelectGroupPopup(true)
            handleOpenSelectGroupPopup(ASSIGNEE_TYPE.LEADER)
          }}
        />
      </div>
      {!isVisibleCreateMissionPopup && leaderList.length > 0 && (
        <SelectList>
          <div style={{ marginBottom: 8 }}>
            {leaderList.map(el => (
              <Tag
                className={'tag-selected'}
                color={'blue'}
                key={el.id}
                closable
                onClose={() => {
                  dispatchUserFilter({
                    type: el.permission,
                    value: null,
                    fullName: null,
                    assigneeType: null,
                  })
                  selectPeopleStore.handleRemoveSelect(el)
                }}>
                <AvatarHasName
                  imgId={el.image_id}
                  size={22}
                  name={el.full_name}
                  icon={
                    (el.assignee_type === ASSIGNEE_TYPE.DEPARTMENT && (
                      <BankOutlined />
                    )) ||
                    (el.assignee_type === ASSIGNEE_TYPE.GROUP && (
                      <TeamOutlined />
                    ))
                  }
                />
              </Tag>
            ))}
          </div>
        </SelectList>
      )}

      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: 8,
        }}>
        <span style={{ color: '#666' }}>Xử lý chính:</span>
        <Button
          icon={<TeamOutlined />}
          style={{ color: '#fa8c16', borderColor: '#d9d9d9' }}
          onClick={() => {
            setIsVisibleSelectGroupPopup(true)
            handleOpenSelectGroupPopup(ASSIGNEE_TYPE.HANDLER)
          }}
        />
      </div>
      {!isVisibleCreateMissionPopup && handlerList.length > 0 && (
        <SelectList>
          <div style={{ marginBottom: 8 }}>
            {handlerList.map(el => (
              <Tag
                className={'tag-selected'}
                color={'blue'}
                key={el.id}
                closable
                onClose={() => {
                  dispatchUserFilter({
                    type: el.permission,
                    value: null,
                    fullName: null,
                    assigneeType: null,
                  })
                  selectPeopleStore.handleRemoveSelect(el)
                }}>
                <AvatarHasName
                  imgId={el.image_id}
                  size={22}
                  name={el.full_name}
                  icon={
                    (el.assignee_type === ASSIGNEE_TYPE.DEPARTMENT && (
                      <BankOutlined />
                    )) ||
                    (el.assignee_type === ASSIGNEE_TYPE.GROUP && (
                      <TeamOutlined />
                    ))
                  }
                />
              </Tag>
            ))}
          </div>
        </SelectList>
      )}

      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: 8,
        }}>
        <span style={{ color: '#666' }}>Phối hợp xử lý:</span>
        <Button
          icon={<TeamOutlined />}
          style={{ color: '#fa8c16', borderColor: '#d9d9d9' }}
          onClick={() => {
            setIsVisibleSelectGroupPopup(true)
            handleOpenSelectGroupPopup(ASSIGNEE_TYPE.COMBINER)
          }}
        />
      </div>
      {!isVisibleCreateMissionPopup && combinerList.length > 0 && (
        <SelectList>
          <div style={{ marginBottom: 8 }}>
            {combinerList.map(el => (
              <Tag
                className={'tag-selected'}
                color={'blue'}
                key={el.id}
                closable
                onClose={() => {
                  dispatchUserFilter({
                    type: el.permission,
                    value: null,
                    fullName: null,
                    assigneeType: null,
                  })
                  selectPeopleStore.handleRemoveSelect(el)
                }}>
                <AvatarHasName
                  imgId={el.image_id}
                  size={22}
                  name={el.full_name}
                  icon={
                    (el.assignee_type === ASSIGNEE_TYPE.DEPARTMENT && (
                      <BankOutlined />
                    )) ||
                    (el.assignee_type === ASSIGNEE_TYPE.GROUP && (
                      <TeamOutlined />
                    ))
                  }
                />
              </Tag>
            ))}
          </div>
        </SelectList>
      )}

      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          marginTop: 24,
        }}>
        <Space>
          <Button type="primary" onClick={handleApply}>
            Áp dụng
          </Button>
          <Button onClick={onClose}>Đóng</Button>
        </Space>
        <Button onClick={handleClear}>Xóa</Button>
      </div>

      <SelectPeoplePopup
        onlySelectOne
        handleCancelSelectUser={handleCancelSelectUserDepartment}
        handleSubmitSelectUser={handleSubmitSelect}
        isVisibleSelectPeoplePopup={isVisibleSelectUserDepartmentPopup}
      />

      <SelectGroupPopup
        onlySelectOne
        groupType={'nhiem_vu'}
        isVisibleSelectGroupPopup={isVisibleSelectGroupPopup}
        handleCancelSelectGroup={handleCancelSelectGroup}
        handleSubmitSelectGroup={handleSubmitSelect}
      />
    </div>
  )
}

Search.propTypes = {}

export default inject(
  'taskStore',
  'departmentStore',
  'loadingAnimationStore',
  'authenticationStore',
  'selectPeopleStore'
)(observer(Search))
